{
  "main": {
    "title": "Šifrant letal",
    "nazaj": "Nazaj"
  },
  "navs": {
    "vnos": "Vnos",
    "seznam": "Seznam",
    "modal": {
      "pregled": "Pregled",
      "servisna": "Servisna k.",
      "wb": "W&B nast."
    }
  },
  "table": {
    "registracija": "Registracija",
    "tip": "Tip",
    "vrsta": "Vrsta",
    "podrobno": "Podrobnosti",
    "s_ure": "Skupaj ur",
    "s_letov": "Skupaj letov"
  },
  "modal": {
    "vlecno": "Vlečno letalo:",
    "obracun_servis": "Beleženje 'Flight':",
    "razpolozljivo": "Vidno v razpoložljivosti:",
    "camo_pregled": "Vidno v Camo pregledu:",
    "camo_flight": "Prikaz 'Flight' v Camo:",
    "tip": "Tip:",
    "model": "Model:",
    "serijska": "Serijska:",
    "masa_plovila": "Teža plovila:",
    "klub": "Klub:",
    "stUr": "Število začetnih ur:",
    "stLetov": "Število začetnih letov:",
    "stSUr": "Ure letenja:",
    "vrsta": "Vrsta letala:",
    "datumN": "Datum nakupa:",
    "datumR": "Datum registracije:",
    "opombaJ": "Opomba jadralno:",
    "opomba": "Opomba:",
    "datumV": "Datum vnosa:",
    "servis": {
      "stSUr": "Stanje ur:",
      "stLetov": "Stanje letov:",
      "interval": "Servisni interval: ",
      "datum_zServis": "Datum zadnjega servisa: ",
      "opravljen_servis": "Servis opravljen pri:",
      "naslednji_servis": "Naslednji servis: ",
      "status": "Status: ",
      "doServisa": "Razlika ur do servisa: ",
      "plovnost": "Letalo je plovno?",
      "plovnost_opomba": "Opomba zakaj letalo ni plovno:"
    },
    "wb": {
      "minCG": "Min. C.G. ({enota}):",
      "maxCG": "Max. C.G. ({enota}):",
      "mTeza": "MTOW ({enota}):",
      "mGorivo": "Gorivo ({enota}):",
      "pTeza": "Prazno letalo ({enota}):",
      "tPilot": "Pilot & Sopotnik -spredaj ({enota}):",
      "tPotniki": "Sopotnik(i) -zadaj ({enota}):",
      "tPrtljaga": "Prtljaga ({enota}):",
      "maxGorivo": "Max. količina goriva ({enota}):",
      "maxPrtljaga": "Max. teža prtljage ({enota}):",
      "imaZadnji": "Letalo ima potnike zadaj(4 sedežno in več)?",
      "wgt": "Wgt {stevilka}:"
    }
  },
  "labels": {
    "vlecno": "Vlečno letalo:",
    "tip": "Tip:",
    "model": "Model:",
    "serijska": "Serijska:",
    "masa_plovila_edit": "Teža letala ({enota}):",
    "klub": "Izberi klub:",
    "stUr": "Število ur:",
    "stLetov": "Število letov:",
    "vrsta": "Izberi vrsto:",
    "datumN": "Datum nakupa:",
    "datumR": "Datum registracije:",
    "opombaJ": "Opomba jadralno:",
    "komponenta": {
      "ime": "Ime komponente",
      "servis_interval": "Servisni interval:",
      "zadnji_servis": "Servis opravljen pri:",
      "naslednji_servis": "Datum naslednjega servisa:",
      "servis_opravljen": "Datum zadnjega servisa:"
    },
    "obracunStevec": "Beleženje 'Flight' časa:",
    "razpolozljivo": "Vidno v razpoložljivosti:",
    "camo_pregled": "Prikaz v CAMO:"
  },
  "buttons": {
    "uredi": "Uredi podatke",
    "posodobi": "Posodobi podatke",
    "brisi": "Izbriši letalo",
    "brisiIzbiro": "Pobriši izbiro",
    "csv": "Izvoz v CSV",
    "servis": {
      "uredi": "Uredi servisne podatke",
      "posodobi": "Posodobi servisne podatke"
    },
    "wb": {
      "uredi": "Uredi w&b podatke",
      "posodobi": "Posodobi w&b podatke"
    },
    "dodajKomponento": "Dodaj komponento"
  }
}